export const state = {
  actionStatus: null,
}

export const getters = {
  getActionStatus: (state) => {
    return state.actionStatus
  },
}

export const mutations = {
  SET_ACTION_STATUS(state, payload) {
    state.actionStatus = payload
  },
}

export const actions = {
  setActionStatus({ commit, state }, payload) {
    commit('SET_ACTION_STATUS', payload)
    return payload
  },
}
